import canadianTheme from './canadianTheme.js';
import globalTheme from './globalTheme.js';
import johnhancockTheme from './johnhancockTheme.js';

var THEMES = {
  canadianTheme: canadianTheme,
  johnhancockTheme: johnhancockTheme,
  globalTheme: globalTheme
};

export default THEMES;
export { THEMES };
